export function LoadingState({label = 'Loading…', rows = 4}) {
  return <div className="ui-loading" aria-live="polite"><span>{label}</span><div>{Array.from({length: rows}, (_, index) => <i key={index}/>)}</div></div>;
}

export function EmptyState({title, message, action}) {
  return <div className="empty ui-empty"><span aria-hidden="true">◇</span><h2>{title}</h2>{message ? <p>{message}</p> : null}{action}</div>;
}
